// extracted by mini-css-extract-plugin
module.exports = {"ReviewModalMobile":"_1GEX4OgsO0gA5YfjrACrVI"};